import { combineReducers } from "redux";
import { loggerReducer } from "../coraWebComponents/utils/logger";
import menu from "./menu/menu";

// user
import user from "./user";
import oAuthUser from "./oAuthUser";
import manual from "./manual";
import verifications from "./verifications";

// header
import header from "./header/header";
import headerListOdberatel from "./header/headerListOdberatel";
import headerListZmluva from "./header/headerListZmluva";
import headerListOM from "./header/headerListOM";

// zmluvy
import zmluva from "./zmluvy/zmluva";
import listZmluva from "./zmluvy/listZmluva";

// odberne miesta
import OM from "./odberneMiesta/OM";
import listOM from "./odberneMiesta/listOM";

// faktury
import faktura from "./faktury/faktura";
import fakturaPDF from "./faktury/fakturaPDF";
import listFaktura from "./faktury/listFaktura";

// spotreby
import spotreba from "./spotreby/spotreba";

// dodavatel
import dodavatel from "./dodavatel/dodavatel";
import dodavatelCurrentUser from "./dodavatel/dodavatelCurrentUser";
import listDodavatel from "./dodavatel/listDodavatel";

// odberatel
import odberatel from "./odberatel/odberatel";
import listOdberatel from "./odberatel/listOdberatel";

// spravy
import countNeprecitaneSpravy from "./spravy/countNeprecitaneSpravy";
import sprava from "./spravy/sprava";
import listSprava from "./spravy/listSprava";

// tables
import aaDefOB from "./tables/aaDefOB";

const rootReducer = combineReducers({
  loggerReducer,
  manual,
  menu,

  // user
  user,
  oAuthUser,
  verifications,

  // app header
  header,
  headerListOdberatel,
  headerListZmluva,
  headerListOM,

  // zmluvy
  zmluva,
  listZmluva,

  // odberne miesta
  OM,
  listOM,

  // faktury
  faktura,
  fakturaPDF,
  listFaktura,

  // spotreby
  spotreba,

  // dodavatel
  dodavatel,
  dodavatelCurrentUser,
  listDodavatel,

  // odberatel
  odberatel,
  listOdberatel,

  // spravy
  countNeprecitaneSpravy,
  sprava,
  listSprava,

  // tables
  aaDefOB,
});

export default rootReducer;
